import { useCallback } from 'react';

import { useToasts } from 'dibs-toaster/exports/useToasts.ts';

import { AddToFolderToastContent, RemoveFromFolderToastContent } from './FolderToastsContent.tsx';
import { SHARED_TOAST_PROPS } from './sharedToastProps.ts';
import { isItemFavoritingVariant, isItemFavoritingFeb2026Variant } from './abTests.ts';
import { trackItemFavoritingToast } from './tracking.ts';

const useFolderToasts = (): {
    addToFolderToast: (portfolio: { portfolioId: string; portfolioName: string }) => void;
    removeFromFolderToast: (portfolio: { portfolioName: string }) => void;
} => {
    const { addToast } = useToasts();

    const addToFolderToast = useCallback(
        ({ portfolioId, portfolioName }: { portfolioId: string; portfolioName: string }) => {
            const isItemFavoritingNov25Variant = isItemFavoritingVariant();
            const isItemFavoritingFeb26Variant = isItemFavoritingFeb2026Variant();
            const shouldShowToast = isItemFavoritingNov25Variant || isItemFavoritingFeb26Variant;

            if (!shouldShowToast) {
                return;
            }

            addToast({
                toast: {
                    ...SHARED_TOAST_PROPS,
                    children: (
                        <AddToFolderToastContent
                            portfolioId={portfolioId}
                            portfolioName={portfolioName}
                        />
                    ),
                },
            });
            trackItemFavoritingToast({ trigger: 'foldered' });
        },
        [addToast]
    );

    const removeFromFolderToast = useCallback(
        ({ portfolioName }: { portfolioName: string }) => {
            const isItemFavoritingNov25Variant = isItemFavoritingVariant();
            const isItemFavoritingFeb26Variant = isItemFavoritingFeb2026Variant();
            const shouldShowToast = isItemFavoritingNov25Variant || isItemFavoritingFeb26Variant;

            if (!shouldShowToast) {
                return;
            }

            addToast({
                toast: {
                    ...SHARED_TOAST_PROPS,
                    children: <RemoveFromFolderToastContent portfolioName={portfolioName} />,
                },
            });
            trackItemFavoritingToast({ trigger: 'folder removed' });
        },
        [addToast]
    );

    return {
        addToFolderToast,
        removeFromFolderToast,
    };
};

export { useFolderToasts };
